Namespace 'Monitoring.Models.SocialContents.LinkedIn.Serializers'

class Monitoring.Models.SocialContents.LinkedIn.Serializers.LinkedInPostSerializer
  serialize: (linkedInPostContent) ->
    {
      mainText: linkedInPostContent.getMainText(),
      createdAt: linkedInPostContent.getCreatedAt(),
      contentID: linkedInPostContent.getCondition(),
      isBrandContent: linkedInPostContent.getIsBrandContent(),
      subType: linkedInPostContent.getSubType()
    }

  deserialize: (json) ->
    builder = new Monitoring.Models.SocialContents.LinkedIn.Builders.LinkedInPostBuilder
    builder.setText(json.text)
    builder.setCreatedAt(json.created_at)
    builder.setContentId(json.content_id)
    builder.setIsBrandContent(json.is_brand_content)
    builder.setContentURN(json.content_urn)
    builder.setHasMedia(json.raw_response.content?.media != undefined)
    linkedInPost = builder.build()
    authorSerializer = new Monitoring.Models.SocialContents.LinkedIn.Serializers.LinkedInAuthorSerializer()
    linkedInAuthor = authorSerializer.deserialize(json.author)
    new Monitoring.Models.SocialContents.LinkedIn.LinkedInPostContent(linkedInAuthor, linkedInPost)
